/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Sağdan sola",
		"timeZoneID": "Saat dilimi",
		"skin": "Stil",
		"metricsFileImportTask": "Dosyalardan Yeni İçe Aktarma",
		"displayMode": "Varsayılan görünüm",
		"credentialRenewed": "Kimlik bilgileriniz geçerli kullanıcı kimliği ve parolanızla yenilendi.",
		"productLocale": "Ürün dili",
		"toggleDisabled": "kapalı",
		"credentialChange": "Yenile",
		"log_level_Debug": "Ayıkla",
		"confirmNewPassword": "Yeni parolayı doğrula",
		"unsavedViewMsg2": "Değişikliklerinizi kaydetmezseniz değişiklikleriniz kaybolur.",
		"supportPortalErrorMessage": "Yeniden deneyin.  Sorun devam ederse sistem yöneticinizle görüşün.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, IBM logosu, ibm.com ve Cognos, International Business Machines Corp.'un dünya çapında birçok farklı hukuk düzeninde kayıtlı bulunan ticari markaları ya da tescilli ticari markalarıdır. IBM ticari markalarının güncel bir listesine Web üzerinde www.ibm.com/legal/copytrade.shtml adresinden ulaşılabilir. Bu Program, Program ile birlikte sağlanan lisans sözleşmesi koşulları kapsamında lisanslanmıştır. Bu lisans sözleşmesi, \"License\" veya \"Non_IBM_License\" adlı bir Program dizini klasöründe ya da kitaplığında bulunabilir ya da basılı bir lisans sözleşmesi olarak sağlanabilir. Lütfen Programı kullanmadan önce sözleşmeyi dikkatli bir biçimde okuyun. Programı kullanarak bu koşulları kabul etmiş olursunuz.",
		"groupsAndRoles": "Gruplar ve roller",
		"metricsMaintenanceTask": "Yeni Bakım",
		"email": "E-posta",
		"contextual": "Bağlamsal",
		"resetHome": "Varsayılan Değere Geri Yükle",
		"ltr": "Soldan sağa",
		"credentials": "Kimlik bilgileri",
		"logging_congfig_title": "Günlüğe kaydetme",
		"changePasswordTitle": "Parolamı değiştir",
		"format": "Rapor biçimi",
		"showUnread": "Okunmamışları göster",
		"AILearning_active": "Yapay Zeka Öğrenme açık:",
		"docsErrorMessage": "Yeniden deneyin.  Sorun devam ederse sistem yöneticinizle görüşün.",
		"toggleEnabled": "açık",
		"homeSetError": "Varsayılan ana sayfa ayarlanırken hata oluştu, bu görünümü kapatıp yeniden açmayı deneyin.",
		"passwordChange": "Parolanızı değiştirin",
		"profile": "Profil",
		"pdfRestricted": "PDF (Kısıtlı)",
		"drillThrough": "Detaya Geçiş tanımlamaları",
		"homeSet": "Ana sayfanız başarıyla ayarlandı",
		"regionalOptions": "Bölgesel seçenekler",
		"myPreferences": "Tercihlerim",
		"defaultHome": "Varsayılan",
		"version": "Sürüm",
		"controller": "Controller",
		"manage": "Yönet",
		"biDirectionalFeaturesEnabled": "İki yönlü dil desteği",
		"newFeaturesErrorTitle": "Yeni Özellikler bağlantısı çalışmadı",
		"passwordMatch": "Parola eşleşmesi",
		"updateProfileAndsettings": "Profil ve ayarları güncelle",
		"dashboardConsole": "Çalışma Alanı",
		"legacyAppsSlideoutLabel": "Kullanılabilir Eski Uygulamalar",
		"logging_config_description": "Sorun giderme için günlük kaydı kullanılıyor. Ayarlarla ilgili yardım için sistem yöneticinizle görüşün.",
		"confirmDeletion": "Silmeyi onayla",
		"signInButtonText": "Oturum aç",
		"dataSourceCredentials": "Veri sunucusu kimlik bilgileri",
		"AILearningConfigurationSlideoutAllyLabel": "Yapay zeka öğrenme yapılandırması",
		"loadingSettings": "Ayarlar yükleniyor",
		"spreadsheetMLRestricted": "Excel (Kısıtlı)",
		"manageAILearning": "Yapay zeka öğrenme",
		"xlsxDataRestricted": "Excel Verileri (Kısıtlı)",
		"advanced": "Gelişmiş seçenekler",
		"ok": "Tamam",
		"changeEmail": "Değişiklik",
		"showHints": "İpuçlarını göster",
		"general": "Genel",
		"xlsxData": "Excel Verileri",
		"newPassword": "Yeni parola",
		"hideAll": "Tümünü gizle",
		"confirmPassword": "Parolayı onayla",
		"AILearning_config_description": "Cognos Analytics'in kullanımınız hakkında bilgi edinmesine izin vererek ürün içi önerileri iyileştirin.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Destek Portalı bağlantısı çalışmadı.",
		"log_level_Warn": "Uyarı",
		"contentSettings": "İçerik ayarları",
		"setHomeButton": "Ayarla",
		"myCapabilities": "Yeteneklerim",
		"homePage": "Ana sayfa",
		"helpErrorMessage": "Yeniden deneyin.  Sorun devam ederse sistem yöneticinizle görüşün.",
		"loadingProfile": "Profil yükleniyor",
		"portal": "Portal",
		"metricsPackage": "Yeni Paket",
		"myCredentials": "Kimlik bilgilerim",
		"credentialCreate": "Oluştur",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Parola güncellenemiyor",
		"showHiddenObjects": "Gizli girdileri göster",
		"csv": "CSV",
		"docsErrorTitle": "Belgeler bağlantısı çalışmadı",
		"log_level_Error": "Hata",
		"wrongPassword": "Kimlik doğrulanamıyor",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Bilgi",
		"welcomeBanner": "Hoş geldiniz başlığı",
		"helpErrorTitle": "Yardım bağlantısı çalışmadı",
		"contentLocale": "İçerik dili",
		"pdf": "PDF",
		"oldPassword": "Eski parola",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Erişilebilirlik özellikleri",
		"manageLogging": "Günlüğe kaydetme",
		"loggingConfigurationSlideoutA11yLabel": "Günlük Kaydı Yapılandırması",
		"communityErrorTitle": "Topluluk bağlantısı çalışmadı",
		"companionApps": "Eşlik eden uygulamalar",
		"setHomeLabel": "Ana sayfayı (geçerli görünüm) olarak ayarla",
		"metricsExportTask": "Yeni Dışa Aktarma",
		"csvRestricted": "CSV (Kısıtlı)",
		"newFeaturesErrorMessage": "Yeniden deneyin.  Sorun devam ederse sistem yöneticinizle görüşün.",
		"contributor": "Contributor",
		"showAll": "Tümünü göster",
		"logging_active": "Günlük kaydı açık:",
		"html": "HTML",
		"profileAndSettings": "Profil ve ayarlar",
		"baseTextDirection": "Metin için temel yön",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Parola",
		"invalidEmail": "Geçerli bir e-posta adresi girin",
		"credentialCreateSuccess": "Kimlik bilgilerinizi başarıyla oluşturdunuz",
		"settings": "Ayarlar",
		"restrictedFormatSelected": "Bu biçimde raporları çalıştırma yeteneğiniz yok, ancak bu biçimde kaydedilen raporlara erişebilirsiniz.",
		"usageDataDeletionConfirmation": "Kullanım verileri silindiğinde, tüm yapay zeka öğrenme işlevi ilk durumuna getirilir.  Kullanım verilerini silmek istediğinizden emin misiniz?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Ayrıntıları görüntüle",
		"deleteUsageData": "Kullanım verilerini sil:",
		"showPassword": "Parolayı göster",
		"AILearning_config_title": "Yapay zeka öğrenme",
		"myPreferencesSlideoutLabel": "Profil ve ayarlar",
		"passWordChangeSuccess": "Parolanızı başarıyla değiştirdiniz",
		"logging_level": "Günlük kaydı düzeyi:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Yeniden deneyin.  Sorun devam ederse sistem yöneticinizle görüşün.",
		"cancel": "İptal",
		"shareSetError": "Bu görünüm kapatılıp yeniden açılmadan bu eylem gerçekleştirilemez.",
		"passwordNotMatch": "Üzgünüz, parola eşleşmiyor",
		"xml": "XML",
		"xmlRestricted": "XML (Kısıtlı)",
		"openMenu": "Menüyü aç",
		"closeMenu": 'Menüyü kapat'
});